import '@symfony/ux-live-component/dist/live.min.css';
export default {
  'live': import(/* webpackMode: "eager" */ '@symfony/ux-live-component/dist/live_controller.js'),
};